import { useQuery } from 'react-query';

import { getAddHubsData } from 'api/traps/Hubs/getAddHubsData';

export const useGetHubsData = (slug: string) => {
  const { data, refetch, isLoading } = useQuery('Hubs', () => getAddHubsData(slug), {
    enabled: !!slug,
    refetchOnWindowFocus: false,
  });

  return { hubOptions: data, refetch, isLoading };
};

export default useGetHubsData;
